a<template>
    <div class="my-5">
        <h3>Attività</h3>
        <div v-for="(input, index) in inputs" :key="index">
            <div class="row align-items-center single-order-activity">
                <div class="col-auto bg-light">
                    {{ (index+1) }}
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col-12">
                            <v-textarea :name="'order_activities[' + index + '][description]'" :label="descriptionLabel" rows="1"
                                v-model="inputs[index].description">
                            </v-textarea>
                        </div>
                        <div class="col">
                            <v-text-field :name="'order_activities[' + index + '][date]'" v-model="inputs[index].date" :label="dateLabel"
                                type="datetime-local">
                            </v-text-field>
                        </div>
                        <div class="col">
                            <v-text-field :name="'order_activities[' + index + '][due_date]'" v-model="inputs[index].due_date" :label="dueDateLabel"
                                type="datetime-local">
                            </v-text-field>
                        </div>
                        <div class="col">
                            <v-select
                                v-model="inputs[index].status"
                                :name="'order_activities[' + index + '][status]'"
                                :label="statusLabel"
                                :items="[
                                    {text: trans('activities.common.pending',1,'it'), value: 'pending'},
                                    {text: trans('activities.common.progress',1,'it'), value: 'progress'},
                                    {text: trans('activities.common.completed',1,'it'), value: 'completed'},
                                    {text: trans('activities.common.canceled',1,'it'), value: 'canceled'}
                                ]"
                                ></v-select>
                        </div>
                        <div class="col">
                            <select-item
                                ref="selectItems"
                                :key="'select-item-' + index"
                                v-model="inputs[index].collaborator_id"
                                :name="'order_activities[' + index + '][collaborator_id]'"
                                :return-object="true"
                                :label="collaboratorLabel"
                                item-value="id"
                                item-text="complete_name"
                                action="/collaborators/list"
                            ></select-item>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <v-file-input
                                chips
                                multiple
                                :name="'order_activities[' + index + '][files][]'"
                                :label="filesLabel"
                                ></v-file-input>
                        </div>
                        <div class="col-lg-6">
                            <div v-for="(singleFile, fileKey) in inputs[index].files" :key="fileKey">
                                <v-banner
                                    lines="one"
                                    color="deep-purple-accent-4"
                                    class="my-2"
                                    >
                                    <v-banner-text>
                                       {{ singleFile }}
                                    </v-banner-text>
                                    <template v-slot:actions>
                                        <v-btn :target="'blank'" :href="singleFile" icon color="blue-lighten-3"><v-icon>download</v-icon></v-btn>
                                    </template>
                                </v-banner>
                            </div>
                            <input type="hidden" 
                                v-model="inputs[index].id"
                                :name="'order_activities[' + index + '][id]'" />
                        </div>
                    </div>
                </div>
                <div v-if="!isSingleActivity" class="col-auto">
                    <div class="d-flex flex-column">
                        <button class="btn btn-danger rounded-circle row-btn" type="button" @click="removeInput(index)">-</button> 
                        <button class="btn btn-info rounded-circle row-btn my-3" type="button" @click="copyInput(index)"><v-icon color="white" :x-small="true">content_copy</v-icon></button> 
                        <button class="btn btn-info rounded-circle row-btn" type="button" @click="pasteInput(index)"><v-icon color="white" :x-small="true">content_paste</v-icon></button> 
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!isSingleActivity" class="text-center">
            <button class="btn row-btn btn-info add-row" type="button" @click="addInput">+</button>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "OrderActivities",
    props: {
        value: {type: Array, default: [{
            id: null,
            description: '',
            due_date: null,
            date: null,
            status: 'pending',
            files: null,
            collaborator_id: null,
        }]},
        isSingleActivity: {default: false},
        label:{default:'Attività'},
        loading:{default:false},
        multiple:{default:false},
        disabled:{default:false},
        required:{default:false},
        name:{},
        rules:{},
        descriptionLabel: {default: 'Descrizione'},
        dueDateLabel: {default: 'Scadenza'},
        dateLabel: {default: 'Data'},
        collaboratorLabel: {default: 'Collaboratore'},
        statusLabel: {default: 'Stato'},
        filesLabel: {default: 'Allegati'},
    },
    data() {
        return {
            copiedValue: null,
        };
    },
    computed: {
        computedCopiedValue: {
            get() {
                if(!this.copiedValue || this.copiedValue.length <= 0) {
                    return null;
                }else {
                    return this.copiedValue;
                }
            },
            set(newValue) {

            }
        },
        inputs: {
            get() {
                if(!this.value || this.value.length <= 0) {
                    return [{
                        id: null,
                        description: '',
                        date: null,
                        due_date: null,
                        status: 'pending',
                        files: null,
                        collaborator_id: null,
                    }];
                }else {
                    return this.value;
                }
            },
            set(newValue) {
                this.$emit('input', newValue);
            }
        }
    },
    methods: {
        addInput() {
            this.inputs.push({
                id: null,
                description: '',
                due_date: null,
                date: null,
                status: 'pending',
                files: null,
                collaborator_id: null,
            });
            this.$emit('input', this.inputs);
        },
        removeInput(index) {
            this.inputs.splice(index, 1);
            this.$emit('input', this.inputs);
        },
        copyInput(index) {
            this.copiedValue = this.inputs[index];
            console.log('copied',this.copiedValue);
        },
        pasteInput(index) {
            if (this.computedCopiedValue) {
                var tempCopiedValue = {...this.computedCopiedValue};
                tempCopiedValue.id = this.inputs[index].id;
                this.inputs.splice(index, 1, tempCopiedValue);
                
                this.$emit('input', this.inputs);

                this.$nextTick(() => {
                    const selectItem = this.$refs.selectItems[index];
                    selectItem.fetchId(this.inputs[index].collaborator_id.id);
                });


            }
        }
    },
};
</script>